module.exports = __webpack_public_path__ + "static/media/logo_horizontal_white.a6c8ecae.png";